import { Logo } from "@/components/Navbar";
import { Link } from "react-router-dom";
import { useAI } from "@/context/AIContext";

export default function Footer() {
  const { openAI } = useAI();

  return (
    <footer className="border-t border-[#1C2A38]/10 bg-[var(--surface)]" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="grid gap-10 md:grid-cols-[1.5fr_1fr_1fr_1fr]">
          <div>
            <Logo />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#5b6878]">
              The robotics sourcing platform. Smarter Sourcing, Faster Builds.
            </p>
          </div>

          <div>
            <h4 className="font-display text-sm font-700 uppercase tracking-wider text-[#1C2A38]">Product</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" data-testid="footer-link-overview" className="text-sm text-[#5b6878] transition-colors hover:text-[var(--teal-deep)]">Overview</Link>
              </li>
              <li>
                <button onClick={() => openAI()} data-testid="footer-link-ai" className="text-sm text-[#5b6878] transition-colors hover:text-[var(--teal-deep)]">AI Sourcing</button>
              </li>
              <li>
                <Link to="/register" data-testid="footer-link-getstarted" className="text-sm text-[#5b6878] transition-colors hover:text-[var(--teal-deep)]">Get started</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-700 uppercase tracking-wider text-[#1C2A38]">Account</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/login" data-testid="footer-link-signin" className="text-sm text-[#5b6878] transition-colors hover:text-[var(--teal-deep)]">Sign in</Link>
              </li>
              <li>
                <Link to="/register" data-testid="footer-link-create" className="text-sm text-[#5b6878] transition-colors hover:text-[var(--teal-deep)]">Create account</Link>
              </li>
              <li>
                <Link to="/dashboard" data-testid="footer-link-dashboard" className="text-sm text-[#5b6878] transition-colors hover:text-[var(--teal-deep)]">Dashboard</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-700 uppercase tracking-wider text-[#1C2A38]">Company</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" data-testid="footer-link-about" className="text-sm text-[#5b6878] transition-colors hover:text-[var(--teal-deep)]">About</Link>
              </li>
              <li>
                <a href="mailto:hello@rosa.tech" data-testid="footer-link-contact" className="text-sm text-[#5b6878] transition-colors hover:text-[var(--teal-deep)]">Contact</a>
              </li>
              <li>
                <a href="mailto:support@rosa.tech" data-testid="footer-link-support" className="text-sm text-[#5b6878] transition-colors hover:text-[var(--teal-deep)]">Support</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-[#1C2A38]/10 pt-6 text-xs text-[#8593a3] sm:flex-row sm:items-center">
          <span className="font-mono-tech">© 2026 ROSA Robotics, Inc.</span>
          <span>Privacy · Terms · Security</span>
        </div>
      </div>
    </footer>
  );
}
